import * as React from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { motion } from 'framer-motion'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'

import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import AuthSection from 'modules/security_settings/pages/SecuritySettingsPage/AuthSection'
import BecomeSection from 'modules/security_settings/pages/SecuritySettingsPage/BecomeSection'
import PasswordRotationSection from 'modules/security_settings/pages/SecuritySettingsPage/PasswordRotationSection'
import SsoSection from 'modules/security_settings/pages/SecuritySettingsPage/SsoSection'
import { useCompanyConfig } from 'modules/security_settings/pages/SecuritySettingsPage/useCompanyConfig'

import DomainSection from './DomainSection'
import HelpFooter from './HelpFooter'

function SecuritySettingsPage() {
  const { company } = useCurrentSession()
  const {
    loading,
    companyConfig: config,
    domainConfig: domains,
    error,
    canUpdateCompanyConfig,
  } = useCompanyConfig(company.id)

  const content = config ? (
    <motion.div initial={{ opacity: 0 }} exit={{ opacity: 0 }} animate={{ opacity: 1 }}>
      <DomainSection domains={domains || []} />
      <SsoSection domains={domains || []} ssoEnforcement={config.ssoEnforcement} />
      <AuthSection mfaStatus={config.mfaStatus} />
      <BecomeSection staffBecomeEnabled={config.staffBecomeEnabled} />
      <PasswordRotationSection
        passwordRotationEnabled={config.passwordRotationEnabled}
        passwordRotationExpireInterval={config.passwordRotationExpireInterval}
      />
      <Box width="full" paddingX="s48" paddingY="s24">
        <HelpFooter />
      </Box>
    </motion.div>
  ) : null

  return (
    <ResponsivePage.Body authorized={canUpdateCompanyConfig} error={error} loading={loading}>
      {content}
    </ResponsivePage.Body>
  )
}

export default React.memo(SecuritySettingsPage)
